module.exports = __webpack_public_path__ + "img/pexel.2356cf0f.png";